import { render, staticRenderFns } from "./add-exam.vue?vue&type=template&id=5ebb895e"
import script from "./add-exam.vue?vue&type=script&lang=ts"
export * from "./add-exam.vue?vue&type=script&lang=ts"
import style0 from "./add-exam.vue?vue&type=style&index=0&id=5ebb895e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports